@if (isBankDetailsFormValid()) {
  <mat-tab-group (selectedTabChange)="handleTabChange($event)">
    <mat-tab label="Добавить новые">
      <div
        class="form-wrapper"
        app-bank-details-form
        [formGroup]="bankDetailsFormGroups()[0]"
        [legalEntityTypes]="legalEntityTypes()"
        [selectedTabIndex]="selectedTabIndex()"
        [isEditModeActive]="true"
        [isNew]="true"
      ></div>
    </mat-tab>
    <mat-tab
      [label]="getCurrentBankDetailsTab()"
      [disabled]="bankDetailsData().length < 1"
    >
      @if (bankDetailsData().length) {
        <div class="bank-details-container">
          <mat-accordion [multi]="true">
            @for (formGroup of bankDetailsFormGroups().slice(1); track $index) {
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    Контрагент: {{ formGroup.get('partner')?.value }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div
                  app-bank-details-form
                  [formGroup]="formGroup"
                  [legalEntityTypes]="legalEntityTypes()"
                  [selectedTabIndex]="selectedTabIndex()"
                  [isEditModeActive]="false"
                  [isNew]="true"
                  (handleAttachClick)="saveButtonClick($index)"
                ></div>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </div>
      }
    </mat-tab>
  </mat-tab-group>
  @if (!selectedTabIndex()) {
    <div class="buttons-container">
      <button
        mat-button
        color="primary"
        [disabled]="!bankDetailsFormGroups().at(0)?.valid"
        (click)="saveButtonClick(-1)"
      >
        Добавить новые
      </button>
    </div>
  }
} @else {
  <app-loader/>
}
